var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2301_10416/2301_10402"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2301_10416/2301_10402)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.7011521875,1.3125L11.3014221875,1.3125000695387Q11.9493921875,1.3125,12.2251921875,1.89883Q12.5009921875,2.48516,12.0877921875,2.98429L8.692952187500001,7.08528L8.692952187500001,12.2709Q8.692952187500001,12.7065,8.3282721875,12.9448Q7.9636021875,13.1831,7.5646521875,13.0081L5.8034721875,12.2358Q5.3217621875,12.0245,5.3217621875,11.4986L5.3217621875,7.0857L1.9159061875,2.98563Q1.5014861875,2.48673,1.7770391875,1.899617Q2.0525901875,1.3125,2.7011521875,1.3125ZM2.7011521875,2.1875Q2.6085031875,2.1875,2.5691381875,2.271374Q2.5297741875,2.35525,2.5889761875,2.42652L6.0958021875,6.64814C6.1610521875,6.72669,6.1967621875,6.82558,6.1967621875,6.9277L6.1967621875,11.4528L7.8179521875,12.1638L7.8179521875,6.9277C7.8179521875,6.82584,7.8534921875,6.72718,7.9184421875,6.64872L11.4137621875,2.42633Q11.4727921875,2.3550199999999997,11.4333921875,2.271262Q11.3939921875,2.1875,11.3014221875,2.1875L2.7011521875,2.1875Z",
    fillRule: "evenodd",
    fill: "#666666",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "media/filter.964df420.svg";
export { ForwardRef as ReactComponent };